import React from 'react';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { FiPlusCircle, FiSave } from "react-icons/fi";
import moment from 'moment';
import DatePicker from "react-datepicker";

const JudgementTable = (props) => (
  <div style={{marginTop: "1rem"}}>
    <Table striped bordered hover size="sm" responsive="sm" className="item-table judge-item-table">
      <thead>
        <tr>
          {props.state.judgementColumns.map((column, index) => (
            <th key={index} style={{ display: column.active ? '' : 'none', whiteSpace: "nowrap", overflow: "hidden" }}>
              {column.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>

        <tr>

          <td>

            <Form.Control as="select" custom value={props.state.itemSelected.client} disabled={props.state.readOnly}
              onChange={e => props.onChanged("judgement", "client", e.target.value)}>

              {props.state.clients.map((client, index) => (
                <option key={index}>{client.name}</option>
              ))}

            </Form.Control>

          </td>

          <td>

            <Form.Control id="refNumber" type="text" value={props.state.itemSelected.refNumber}
              onChange={e => props.onChanged("summons", "refNumber", e.target.value)} readOnly={props.state.readOnly} />

          </td>

          <td>

            <Form.Control as="select" custom value={props.state.itemSelected.judgement[0].plaintiff} disabled={props.state.readOnly}
              onChange={e => props.onChanged("judgement", "plaintiff", e.target.value)}>

              {props.state.plaintiffs.map((plaintiff, index) => (
                <option key={index}>{plaintiff.name}</option>
              ))}

            </Form.Control>

          </td>

          <td>

            <Form.Control id="defendant" type="text" value={props.state.itemSelected.defendant}
              onChange={e => props.onChanged("judgement", "defendant", e.target.value)} readOnly={props.state.readOnly} />

          </td>

          <td>
            <Form.Control as="select" custom value={props.state.itemSelected.judgement[0].judgeProcess} disabled={props.state.readOnly}
              onChange={e => props.onChanged("judgement", "judgeProcess", e.target.value)}>

              {props.state.judgeProcess.map((process, index) => (
                <option key={index}>{process.name}</option>
              ))}

            </Form.Control>
          </td>

          <td>

            <Form.Control as="select" custom value={props.state.itemSelected.judgement[0].court} disabled={props.state.readOnly}
              onChange={e => props.onChanged("judgement", "court", e.target.value)}>

              {props.state.courts.map((court, index) => (
                <option key={index}>{court.name}</option>
              ))}

            </Form.Control>

          </td>

          <td>

            <Form.Control id="batchNumber" type="text" value={props.state.itemSelected.batchNumber}
              onChange={e => props.onChanged("judgement", "batchNumber", e.target.value)} readOnly={props.state.readOnly} />

          </td>

          <td>

            <Form.Control id="caseNumber" type="text" value={props.state.itemSelected.judgement[0].caseNumber}
              onChange={e => props.onChanged("judgement", "caseNumber", e.target.value)} readOnly={props.state.readOnly} />

          </td>

          <td>

            <DatePicker id="dateLodged" dateFormat="dd/MM/yyyy"value={props.state.itemSelected.judgement[0].dateLodged} disabled={props.state.readOnly}
              onChange={date => props.onChanged("judgement", "dateLodged", moment(date).format("DD/MM/YYYY"))}
              onChangeRaw={(event) => props.removeDate("judgement", "dateLodged")}/>

          </td>

          <td>

            <Form.Control as="select" custom value={props.state.itemSelected.judgement[0].otherStatus} disabled={props.state.readOnly}
              onChange={e => props.onChanged("judgement", "otherStatus", e.target.value)}>

              {props.state.status.map((status, index) => (
                <option key={index}>{status.name}</option>
              ))}

            </Form.Control>

          </td>

          <td>

            <DatePicker id="statusDate" dateFormat="dd/MM/yyyy" value={props.state.itemSelected.judgement[0].statusDate} disabled={props.state.readOnly}
              onChange={date => props.onChanged("judgement", "statusDate", moment(date).format("DD/MM/YYYY"))}
              onChangeRaw={(event) => props.removeDate("judgement", "statusDate")}/>

          </td>

          <td>

            <DatePicker popperPlacement="left-start" id="toClient" dateFormat="dd/MM/yyyy" value={props.state.itemSelected.judgement[0].toClient} disabled={props.state.readOnly}
              onChange={date => props.onChanged("judgement", "toClient", moment(date).format("DD/MM/YYYY"))}
              onChangeRaw={(event) => props.removeDate("judgement", "toClient")}/>

          </td>

        </tr>

      </tbody>
    </Table>

    <Accordion className="notes-accordion" defaultActiveKey="0">
      <Card>
        <Card.Header>
          <Accordion.Toggle className="notes-toggle-button" as={Button} variant="text" eventKey="0">
            Show Notes
          </Accordion.Toggle>
          <FiPlusCircle className="ml-2 add-note-icon" onClick={e => props.addNewNote("judgement")}
            style={{display: props.state.readOnly ? "none" : ""}}/>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>

            <Table className="item-notes-table" size="sm">
              <tbody>

                {props.state.itemSelected.judgement[0].notes.map((note, index) => (
                  <tr key={index}>
                    <td style={{width: "7%"}}>{note.createdOn}</td>
                    <td style={{width: "13%"}}>{note.createdBy}</td>
                    <td style={{width: "80%"}}>
                      {note.new ?

                        <InputGroup className="">
                          <Form.Control placeholder="Enter note text" onChange={e => note.note = e.target.value}/>
                          <InputGroup.Append>
                            <InputGroup.Text id="basic-addon2">
                              <FiSave onClick={e => props.onChanged("judgement", "note", note, index)} />
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>

                      : note.note}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  </div>
);

export default JudgementTable;
